import CalenderContainer from "../../Componant/Calendar";

const Calendar = () => {
  return (
    <div className="page-body">
      <CalenderContainer />
    </div>
  );
};

export default Calendar;
